module.exports = __webpack_public_path__ + "media/packs/landing_page/images/como_funciona-fc8290392f1a67818183d3ff479ed98f.png";